import React, { Component } from 'react'
import api from '../../../api/api';
import ParadigmaTable from '../../../components/ParadigmaTable/ParadigmaTable';
import Modal from './Modal';

export default class TiposConvenios extends Component {
    constructor(props){
        super(props);
        this.state={
            filter:[],
            columns:[
                {
                    Header: 'pk',
                    id: 'pk',
                    accessor: 'pk',
                    show: false,
                    private:true,
                },
                {
                    Header: 'Tipo',
                    id: 'nombre',
                    accessor: 'nombre',
                    show: true,
                }
            ],
        }
    }
  render() {
    return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        permission: 'consultas_convenios_detail',
                        component: (props) => <Modal {...props} action="CREATE"/>
                    },
                {
                    edit: true,
                    permission: 'consultas_convenios_detail',
                    component: (props) => <Modal {...props} action="EDIT" />
                },
                    {
                        edit: true,
                        permission: 'consultas_convenios_detail',
                        component: (props) => <Modal {...props} action="DELETE"/>
                    },
                ]}
                outerFilter={this.state.filter}
                apiUrl={api.proyectos.cargadatos.convenios.tipos.list}
                columns={this.state.columns}
                title={"Tipos de Convenio"}
            />
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Convenios/Tipos/TiposConvenios.js